import React from "react"
import { Link } from "gatsby"
import Footer from "../footer"
import withAnalyticsContext from '../../lib/hocs/withAnalyticsContext';

class Footers extends React.Component {

  applyClick = () => {
    this.props.analytics.logEvent('shop_apply_clicked', { button: '3' });
  }
  
  inquiryClick = () => {
    this.props.analytics.logEvent('shop_inquiry_clicked', { button: '3' });
  }

  telClick = () => {
    this.props.analytics.logEvent('shop_inquiry_clicked');
  }
  
  render() {
    return (
      <div className="footers">
        <div className="application">
          <div className="has-text-centered">
            <h2 data-aos="fade-up" className="title is-1">
              加盟店お申込みはこちら
            </h2>
            <div data-aos="fade-up">
              <a
                className="button is-size-medium is-primary is-inverted is-rounded"
                href="https://start.picks.fun/apply"
                onClick={this.applyClick}
              >
                WEBお申し込み
              </a>
            </div>
          </div>
        </div>
        <div className="inquiry">
          <div className="has-text-centered">
            <h2 data-aos="fade-up" className="title">
              サービス内容・導入に関する<span>ご相談はこちら</span>
            </h2>
            <div data-aos="fade-up">
               お申込みに関するお問い合わせや導入のご相談をWebにて対応しています。
              <br />        
                お気軽にお問い合わせください。
            </div>
            <div data-aos="fade-up" className="contacts">
              <div className="is-inquiry">
                <a
                  className="button is-size-normal is-primary is-rounded"
                  href="https://start.picks.fun/inquiry"
                  onClick={this.inquiryClick}
                >
                  お問い合わせ
                </a>
                <div className="open-time">
                  【受付時間】24時間/365日
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    )
  }
}

export default withAnalyticsContext(Footers)
